import {
  RECEIVE_BILLABLEITEM,
  RECEIVING_BILLABLEITEM,
  RECEIVE_BILLABLEITEM_METADATA,
  SAVING_BILLABLEITEM,
  UPDATING_BILLABLEITEM,
  DELETE_BILLABLEITEM,
  DELETING_BILLABLEITEM,
  RESET_BILLABLEITEM_META,
  CLEAR_BILLABLEITEM_STATE,
  CLEAR_STATE,
  INCREMENT_BILLABLEITEM_COUNT,
  SET_ALL_BILLABLEITEM_LOADED
} from '@/store/mutationTypes'
import {
  receiveData,
  deleteData,
  increment,
  receiveMetadata,
  resetMetadata,
  clearLocalState,
  clearState
} from '@/store/modules/helpers/mutationHelpers'

const state = {
  data: {},
  cache: {},
  count: null,
  shown: null,
  currentPage: 1,
  saving: false,
  receivingData: false,
  updating: null,
  deleting: false,
  allBillableitemLoaded: false
}

const actions = {
  setBillableitemPreloadStatus (store, payload) {
    this.commit(SET_ALL_BILLABLEITEM_LOADED, payload)
  },
  clearBillableitemState (store, clearCache = false) {
    this.commit(CLEAR_BILLABLEITEM_STATE, clearCache)
  }
}

const getters = {
  getBillableitem: (state) => {
    return state.data ? Object.values(state.data).map(v => Object.assign({}, v)) : []
  },
  getAllBillableitem: (state) => {
    return state.cache ? Object.values(state.cache).map(v => Object.assign({}, v)) : []
  },
  getBillableitemMetadata: (state) => {
    const { shown, count } = state
    if (!shown) return { count: 0, shown: 0 }
    return { count, shown }
  },
  getBillableitemById: (state, rootState) => (id) => {
    if (state.data && state.data[id]) {
      return state.data[id]
    } else if (state.cache && state.cache[id]) {
      return state.cache[id]
    } else {
      return {}
    }
  },
  getDefaultBillableitem: (state) => {
    return Object.values(state.cache).find(v => v.active) || {}
  },
  getBillableitemFetchStatus: (state) => {
    return state.receivingData
  },
  getBillableitemSaveStatus: (state) => {
    return state.saving
  },
  getBillableitemUpdateStatus: (state) => {
    return state.updating
  },
  getBillableitemDeleteStatus: (state) => {
    return state.deleting
  }
}

const mutations = {
  [RECEIVE_BILLABLEITEM] (state, results) {
    receiveData(state, results)
  },
  [RECEIVING_BILLABLEITEM] (state, payload) {
    state.receivingData = payload
  },
  [SAVING_BILLABLEITEM] (state, payload) {
    state.saving = payload
  },
  [UPDATING_BILLABLEITEM] (state, payload) {
    state.updating = payload
  },
  [DELETE_BILLABLEITEM] (state, payload) {
    deleteData(state, payload)
  },
  [DELETING_BILLABLEITEM] (state, payload) {
    state.deleting = payload
  },
  [INCREMENT_BILLABLEITEM_COUNT] (state, payload) {
    increment(state, payload)
  },
  [RECEIVE_BILLABLEITEM_METADATA] (state, payload) {
    receiveMetadata(state, payload)
  },
  [CLEAR_BILLABLEITEM_STATE] (state, payload) {
    clearLocalState(state, payload)
  },
  [RESET_BILLABLEITEM_META] (state) {
    resetMetadata(state)
  },
  [CLEAR_STATE] (state) {
    clearState(state)
  },
  [SET_ALL_BILLABLEITEM_LOADED] (state, payload) {
    state.allBillableitemLoaded = payload
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}
